// Allowed characters for user-facing titles (chat group names, talk/project
// titles): accented latin letters, letters, digits, space and a small set of
// punctuation. Mirrors the rule used for talk titles in NewThread.vue, but with
// the global flag so *all* disallowed characters are stripped (e.g. on paste),
// not just the first occurrence.
const TITLE_ALLOWED_CHARS_REGEX = /[^À-ſA-Za-z\d \-.,@$€%=?!()[\]/]+/g;

/**
 * Strips characters that are not allowed in titles/names. Used to sanitize the
 * chat group name input the same way talk/project titles are restricted.
 */
const sanitizeTitleInput = (value: string): string => value.replace(TITLE_ALLOWED_CHARS_REGEX, '');

export default sanitizeTitleInput;
